export default __webpack_public_path__ + "static/media/game.2e87ab1c.jpg";